<!--app-pick-services (pickSlotActive)="setPickSlotActive($event)" [real]="real"
></app-pick-services-->

<ion-grid class="ion-no-padding">
  <ion-row>
    <!-- [ngClass]="{'hidden-sm-down': i===1, 'hidden-lg-down': i>1}"-->
    <ion-col *ngFor="let event of (events$ | async); let i = index;" size-xs="12" size-md="12" size-lg="6" size-xl="6">
      <app-event-card [event]="event"></app-event-card>
    </ion-col>
 </ion-row>
</ion-grid>


<!-- O SALONU START -->

<div *ngIf="this.currentUrl == '/vip-gourmet-klub'" class="ion-padding about-saloon" style="padding-top:0px;">
  
  <div class="about-saloon__desc expanded" style="white-space:pre-wrap;">

    <h3 class="about-saloon__title">VIP GOURMET KLUB</h3>

    <p><b>VIP GOURMET KLUB</b> je posebna kulinarična vstopnica za izbrane športne dogodke.</p>

    <p>Namenjen je vsem, ki prisegate na vrhunske razglede, nepozabne športne trenutke in brezkompromisno uživanje v izvrstni kulinariki.</p>

    <p>Vsak dogodek v okviru VIP GOURMET KLUBA združuje strast do športa in ljubezen do odlične hrane. Gre za edinstveno doživetje, v katerem lahko uživate sami, v družbi prijateljev, poslovnih partnerjev – ali s komerkoli, ki zna ceniti vrhunske trenutke na edinstven način.</p>

    <p>Pridružite se <b>STRASTNIM NAVIJAČEM in NEUSTRAŠNIM UŽIVAČEM</b> – ter doživite šport, kot ga še niste!</p>

  </div>

</div>

<div *ngIf="this.currentUrl != '/vecerja-na-zajli' && this.currentUrl != '/vip-gourmet-klub'" class="ion-padding about-saloon" style="padding-top:0px;">
  <h3 class="about-saloon__title">AKADEMIJA JE PRILOŽNOST. ODKRIJTE SKRIVNOSTI KULINARIKE.</h3>

  <div class="about-saloon__desc expanded" style="white-space:pre-wrap;"> 
    <p class="formatted" [innerHtml]="'Dobrodošli vsi tisti, ki s strahom pričakujete tasta in taščo na kosilu ali pa ste že zdavnaj obupali nad tem, da bi kdaj sami zamesili kruh ... ali pa skuhali kosilo s tremi hodi ... da ne govorimo o peki potice.<br/><br/>Dobrodošli pa tudi vsi tisti, ki ste daleč naokoli poznani po svojih kuharskih veščinah, pa vseeno dan pred napovedano večerjo zelo slabo spite, priprava kosila pa vam vzame cel dan; kako tudi ne, boste rekli, »priprava takšnih kulinaričnih specialitet pač traja...«<br/><br/>Se strinjamo z vami, naj vam pa ob tem zaupamo še tiste male skrivnosti, zaradi katerih bo priprava potekala hitreje, kosilo pa bo tudi za vas takšna sprostitev, kot za tiste, ki si že samo ob misli na kulinarično popoldne pri vas oblizujejo prste.'"></p></div>

  <div class="about-saloon__info">
    <h5><span *ngIf="real?.provider.brandName !== real?.name && real?.provider.slug !== 'jezersek'">{{ real?.provider.brandName }} </span>{{ real?.name }}</h5>
    <p>{{ real?.address }}</p>
  </div>




  <div *ngIf="real?.freeParking || real?.parkingInfo" class="about-saloon__parking">

    <p>
      <ion-icon style="font-size: 27px !important;" name="car" mode="md"></ion-icon>
      <span *ngIf="real?.freeParking">{{ 'SHOP_DETAIL.FREE_PARKING' | translate }}</span>
      <span *ngIf="!real?.freeParking">{{ 'SHOP_DETAIL.PARKING' | translate }}</span>
    </p>
    
    <p>{{ real?.parkingInfo }}</p>

  </div>


  <div class="about-saloon__contact">

    <p>
      <a [href]="'tel:' + real?.phone1" style="text-decoration: none;">
      <ion-icon  name="call" mode="md"></ion-icon><span *ngIf="translateService.currentLang !== 'sl'">{{ real?.phone1 || '' | internationalFormat : 'SI' }}</span><span *ngIf="translateService.currentLang == 'sl'">{{ real?.phone1 || '' | nationalFormat : 'SI' }}</span></a> - delovniki med 8.00 in 16.00
    </p>

    <p>
      <a [href]="'mailto:akademija@jezersek.si'" style="text-decoration: none;">
      <ion-icon  name="mail" mode="md"></ion-icon>akademija@jezersek.si</a>
    </p>


    <p>
      <a *ngIf="real?.website" [href]="((real?.website.substr(0,4) === 'http')?'':'https://') + real?.website" target="_blank" style="text-decoration: none;">
      <ion-icon  name="globe-outline" mode="md"></ion-icon></a>

      <a *ngIf="real?.instagram" [href]="'https://instagram.com/' + real?.instagram + '/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-instagram" mode="md"></ion-icon></a>

      <a *ngIf="real?.facebook" [href]="'https://facebook.com/' + real?.facebook +'/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-facebook" mode="md"></ion-icon></a>
    </p>

    <p *ngIf="false && real?.website">
      <a [href]="((real?.website.substr(0,4) === 'http')?'':'https://') + real?.website" target="_blank" style="text-decoration: none;">
      <ion-icon  name="globe-outline" mode="md"></ion-icon>{{ real?.website }}</a>
    </p>

    <p *ngIf="false && real?.instagram">
      <a [href]="'https://instagram.com/' + real?.instagram + '/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-instagram" mode="md"></ion-icon>{{ real?.instagram }}</a>
    </p>

    <p *ngIf="false &&  real?.facebook">
      <a [href]="'https://facebook.com/' + real?.facebook +'/'" target="_blank" style="text-decoration: none;">
      <ion-icon  name="logo-facebook" mode="md"></ion-icon>{{ real?.facebook }}</a>
    </p>


    <p *ngIf="real?.googleMaps">
      <a [href]="'https://maps.app.goo.gl/' + real?.googleMaps" target="_blank" style="text-decoration: underline; text-decoration-style: dotted;">
      <ion-icon class="google-maps" style="font-size:20px"></ion-icon>{{ 'SHOP_DETAIL.GOOGLE_MAPS_LINK' | translate }}</a>
    </p>

  </div>


</div>
